import { CellText, Table, useTable } from '@backstage/ui';
import type { ColumnConfig } from '@backstage/ui';
import type { FindingRow } from '../../hooks/useProjectScorecard';

const columnConfig: ColumnConfig<FindingRow>[] = [
  {
    id: 'evidence',
    label: 'Evidence',
    isRowHeader: true,
    cell: row => <CellText title={row.finding} />,
  },
  {
    id: 'reason',
    label: 'Reason',
    cell: row => <CellText title={row.reason} />,
  },
];

interface FactValueFindingsProps {
  findings: FindingRow[];
}

export function FactValueFindings({ findings }: FactValueFindingsProps) {
  const { tableProps } = useTable<FindingRow, never>({
    mode: 'complete',
    data: findings,
    paginationOptions: { type: 'none' },
  });

  if (findings.length === 0) return null;

  return <Table {...tableProps} columnConfig={columnConfig} />;
}
